// extracted by mini-css-extract-plugin
export default {"container":"StaffCard_container__qIwS6","hoverOverlay":"StaffCard_hoverOverlay__x6SOc","detailSection":"StaffCard_detailSection__ple5k"};